import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {CommandService} from '@core/services/command.service';
import {PlatformCommand} from '@shared/commands/command-base';
import {Api} from '@shared/constants/common-field.constants';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HomeGuard implements CanActivate {
  constructor(private router: Router, private commandService: CommandService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    const command = new PlatformCommand('HomeRedirectCommand', Api.Security);
    command.waitForResponse = true;
    return this.commandService.executePlatformCommand(command).pipe(map((res) => {
      const redirectUrl = res.fieldValues['RedirectUrl'];

      if (!redirectUrl) {
        return true; // Allow navigation
      } else {
        this.router.navigate([redirectUrl]); // Redirect to an unauthorized route
        return false; // Deny navigation
      }
    }));
  }
}
